import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

export interface BreadcrumbItem {
  label: string;
  /** When present, item is a link; when absent, item is current page (last breadcrumb). */
  routerLink?: string[];
  /** Optional query params when using routerLink */
  queryParams?: Record<string, string | number>;
  /** Optional navigation state passed via History API */
  state?: { [k: string]: unknown };
  /** When false, label is shown as-is; otherwise passed through translate pipe. Default true. */
  translate?: boolean;
}

@Component({
    selector: 'ts-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TranslateModule, RouterModule]
})
export class BreadcrumbsComponent {
  @Input() items: BreadcrumbItem[] = [];
  @Input() loading = false;
}
